export const conceptBlockLeftDesktopBg = '/images/original-plus/concept-block-left-desktop.png';
export const conceptBlockLeftMobileBg = '/images/original-plus/concept-block-left-mobile.png';
export const conceptBlockRightDesktopBg = '/images/original-plus/concept-block-right-desktop.png';
export const conceptBlockRightMobileDecorSrc =
  '/images/original-plus/concept-block-right-mobile-decor.png';
export const conceptBlotchSrc = '/images/original-plus/concept-blotch.webp';
export const conceptListCheckSrc = '/images/original-plus/badge-check.png';

export const leftConceptListItems = [
  'Фанфики и ориджиналы на равных',
  'Можно развивать оба направления',
  'Кураторский отбор',
  'Оценка текста, целей и потенциала',
  'Индивидуальный маршрут',
  'Статус участника, а не подписка',
] as const;

export const rightConceptListItems = [
  'Развитие текста и авторского голоса',
  'Упаковка автора и произведения',
  'Поиск и развитие аудитории',
  'Продвижение и дистрибуция',
  'Подборки, сборники и медиа',
  'События, коллаборации и индустрия',
] as const;
